import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { COMMAND_CENTER_SUMMARY_ACTION_TYPE } from '../actions/commandCenterSummary.actions';

const initialState = null;

const commandCenterSummaryReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case COMMAND_CENTER_SUMMARY_ACTION_TYPE.SET_SUMMARY:
        return payload ?? initialState;

      case RESET_STATE:
        return initialState;

      default:
        return draft;
    }
  });

export default commandCenterSummaryReducer;
